import { render, staticRenderFns } from "./OPDInfo.vue?vue&type=template&id=0abc4d5a&scoped=true"
import script from "./OPDInfo.vue?vue&type=script&lang=js"
export * from "./OPDInfo.vue?vue&type=script&lang=js"
import style0 from "./OPDInfo.vue?vue&type=style&index=0&id=0abc4d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc4d5a",
  null
  
)

export default component.exports